// anime.js is fetched only when an animated heading is on the page.
const loadAnime = () => import('animejs').then((m) => m.default);

const imageBanner = (settings) => ({
    imageBanner: null,
    bannerMedia: null,
    headerGroup: null,
    announcementBar: null,
    headerHeight: 0,
    template: null,
    enableAnimation: false,
    index: null,
    id: null,
    ...settings,

    init() {
        window.addEventListener("load", ()=>{
            this.template = document.querySelector("main").getAttribute("data-template")
            this.imageBanner = document.querySelectorAll(".image-banner__section")
            this.announcementBar = document.querySelector(".announcement-bar")
            this.headerGroup = document.querySelector(".header-group")

            if (this.headerGroup){
                if (this.announcementBar){
                    this.headerHeight = this.announcementBar.offsetHeight + this.headerGroup.offsetHeight
                }else{
                    this.headerHeight = this.headerGroup.offsetHeight
                }
            }
        })

        this.initAnimation()
    },
    async initAnimation(){
        if (this.enableAnimation){
            const anime = await loadAnime();
            const ANIMATION_DELAY = 700;
            const LETTER_DELAY = 50;
            const ANIMATION_DURATION = 2500;
            const CLASS_SPEEDY_ANIMATION_DURATION = ANIMATION_DURATION - 700;

            var textWrapper = this.$el.querySelector('.heading');
            if (!textWrapper) return;

            textWrapper.style.opacity = 1;

            const text = textWrapper.textContent;
            // textWrapper.innerHTML = text.replace(/\S/g, "<span class='letter'>$&</span>");
            const arrayWords = text?.trim()?.split(' ')?.map((word, index) => {
                return `<span class="animation-overlap-letters"><span class='letter'>${word}</span></span>`
            });


            if (!arrayWords) return;
            textWrapper.innerHTML = arrayWords.join(' ');

            // textWrapper.innerHTML = text.replace(/\S/g, "<span class='letter'>$&</span>");

            anime.timeline({
                loop: false
            })
            .add({
                targets: (`#${this.id} .heading .letter`),
                translateY: [110, 0],
                translateZ: 0,
                rotateZ: [10, 0],
                opacity: [0, 1],
                easing: "easeOutExpo",
                duration: ANIMATION_DURATION,
                delay: (el, i) => ANIMATION_DELAY + LETTER_DELAY * i
            });

            setTimeout(() => {
                this.$el.classList.add('animation-completed');
            }, CLASS_SPEEDY_ANIMATION_DURATION);
        }
    }
})

export default imageBanner

document.addEventListener("alpine:init", () => {
    Alpine.data("imageBanner", imageBanner);
})
